const PORT = location.port ? `:${location.port}` : ''
const base = location.protocol + '//' + location.hostname + PORT + '/';
const api = 'api/v1/'
const apiBase = base + api;
const auth = 'auth/'

const LANGUAGE_PREFIX_PATTERN = /^\/([a-z]{2}(?:-[a-z]{2})?)(?=\/|$)/i;

export const localizeAppPageUrl = (value) => {
    let target;
    try {
        target = new URL(String(value || ''), window.location.origin);
    } catch (error) {
        return String(value || '');
    }
    if (target.origin !== window.location.origin) {
        return target.href;
    }
    const languageMatch = window.location.pathname.match(LANGUAGE_PREFIX_PATTERN);
    if (!languageMatch) {
        return target.href;
    }
    const language = languageMatch[1];
    const pathname = target.pathname.replace(/^\/+/, '/');
    target.pathname = LANGUAGE_PREFIX_PATTERN.test(pathname)
        ? pathname.replace(LANGUAGE_PREFIX_PATTERN, `/${language}`)
        : `/${language}${pathname}`;
    return target.href;
};


const urls = {
    base: base,
    getAds: base + api + 'inventories/list/',
    bot: base + api + 'bots/fake/',
    botCreate: base + api + 'bots/create/',
    botSwitch: base + api + 'bots/switch/',
    botCopy: base + api + 'bots/copy/',
    botAdvertConnections: (botId) => `${apiBase}bots/${botId}/advert-connections/`,
    botActions: base + api + 'bots/actions/',
    botTemplates: base + api + 'bots/templates/',
    botGet: base + api + 'bots/bot/',
    templateGet: base + api + 'bots/template/',
    botUpdate: base + 'bots/update/',
    connections: base + api + 'connections/all/',
    connect: base + api + 'connections/connect/',
    disconnect: base + api + 'connections/disconnect/',
    botConnections: base + api + 'connections/bot/',
    disconnectTelegram: base + api + 'settings/disconnect_telegram/',
    notificationsSettings: base + api + 'settings/notifications/',
    setNewPassword: base + api + 'settings/set_password/',
    setBotGuide: base + api + 'settings/set_bot_guide/',
    setBotVideoTutorial: base + api + 'settings/set_bots_video/',
    setAccountsGuide: base + api + 'settings/set_accounts_guide/',
    botSimple: base + api + 'bots/simple/',
    accounts: base + api + 'olx-accounts/list/',
    accountSwitch: base + api + 'olx-accounts/switch/',
    accountPlacementBalance: (accountId) => `${base + api}olx-accounts/${accountId}/placement-balance/`,
    accountPlacementResources: (accountId) => `${base + api}olx-accounts/${accountId}/placement-resources/`,
    accountPlacementPackagePreview: (accountId) => `${base + api}olx-accounts/${accountId}/placement-packages/preview/`,
    accountPlacementPackagePurchase: (accountId) => `${base + api}olx-accounts/${accountId}/placement-packages/purchase/`,
    accountPlacementPackageSchedule: (accountId) => `${base + api}olx-accounts/${accountId}/placement-packages/schedule/`,
    accountsPage: base + '/olx-accounts/',
    adsPage: base + 'inventories/',
    scheduledActionsPage: base + 'inventories/scheduled-actions/',
    billingPage: base + 'billing/',
    billingPurchasePage: base + 'billing/purchase/',
    billingSubscribePage: base + 'billing/subscribe/',
    billingHistoryPage: base + 'billing/history/',
    creemCatalog: base + api + 'billing/catalog/',
    creemCheckout: base + api + 'billing/creem/checkout/',
    creemCheckoutStatus: (requestId) => `${base + api}billing/creem/checkout/${requestId}/status/`,
    creemCheckoutResultPage: (requestId) => `${base}billing/creem/result/${requestId}/`,
    creemCustomerPortal: base + api + 'billing/creem/customer-portal/',
    creemSubscription: base + api + 'billing/creem/subscription/',
    creemSubscriptionMutation: base + api + 'billing/creem/subscription/mutate/',
    creemSubscriptionReconcile: base + api + 'billing/creem/subscription/reconcile/',
    placementOperationPage: (operation = 'activate') => `${base}inventories/placement-operation/${operation}/`,
    olxAdEditPage: (accountId, adId) => `${base}inventories/olx-ads/${accountId}/${adId}/edit/`,
    draftsPage: base + 'inventories/drafts/',
    draftCreatePage: base + 'inventories/drafts/create/',
    draftEditPage: (draftId) => `${base}inventories/drafts/${draftId}/edit/`,
    category: base + api + 'inventories/categories/',
    categorySchema: (categoryId) => `${base + api}inventories/categories/${categoryId}/schema/`,
    regions: base + api + 'inventories/regions/',
    cities: base + api + 'inventories/cities_list/',
    districts: base + api + 'inventories/districts/',
    locationAutocomplete: (query, limit = 10) => `${base + api}inventories/locations/autocomplete/?query=${encodeURIComponent(query)}&limit=${encodeURIComponent(limit)}`,
    contactLibrary: base + api + 'inventories/contacts/',
    contactNames: base + api + 'inventories/contacts/names/',
    contactNameDetail: (contactId) => `${base + api}inventories/contacts/names/${contactId}/`,
    contactPhones: base + api + 'inventories/contacts/phones/',
    contactPhoneDetail: (contactId) => `${base + api}inventories/contacts/phones/${contactId}/`,
    descriptionTemplates: base + api + 'inventories/description-templates/',
    descriptionTemplateDetail: (templateId) => `${base + api}inventories/description-templates/${templateId}/`,
    currencies: base + api + 'inventories/currencies/',
    priceCurrencies: base + api + 'inventories/price-currencies/',
    imageAssets: (query = '', limit = 24, offset = 0, purpose = 'olx_ad', ids = []) => `${base + api}files/images/?q=${encodeURIComponent(query)}&limit=${encodeURIComponent(limit)}&offset=${encodeURIComponent(offset)}&purpose=${encodeURIComponent(purpose)}${ids.length ? `&ids=${encodeURIComponent(ids.join(','))}` : ''}`,
    imageAssetsUpload: base + api + 'files/images/',
    imageAssetsDelete: base + api + 'files/images/delete/',
    imageAssetDetail: (imageId) => `${base + api}files/images/${imageId}/`,
    draftList: base + api + 'inventories/drafts/',
    draftImportCsv: base + api + 'inventories/drafts/import-csv/',
    draftCopyFromOlx: base + api + 'inventories/drafts/copy-from-olx/',
    draftDelete: base + api + 'inventories/drafts/delete/',
    draftPublishNow: base + api + 'inventories/drafts/publish-now/',
    backupImageProxySession: base + api + 'inventories/backups/image-proxy-session/',
    priceUpdates: base + api + 'inventories/price-updates/',
    placementPlanPreview: base + api + 'inventories/placement-plans/preview/',
    placementResourcePreviewJobs: base + api + 'inventories/placement-plans/resource-preview-jobs/',
    placementResourcePreviewJob: (jobId) => `${base + api}inventories/placement-plans/resource-preview-jobs/${jobId}/`,
    placementPlanPurchasePackage: base + api + 'inventories/placement-plans/purchase-package/',
    placementPlanSingleAdPricingDiagnostics: base + api + 'inventories/placement-plans/single-ad-pricing-diagnostics/',
    bumpPreview: base + api + 'inventories/bump/preview/',
    bump: base + api + 'inventories/bump/',
    advertisingPreview: base + api + 'inventories/advertising/preview/',
    advertising: base + api + 'inventories/advertising/',
    paidFeaturePreview: base + api + 'inventories/paid-features/preview/',
    paidFeaturePreviewJobs: base + api + 'inventories/paid-features/preview-jobs/',
    paidFeaturePreviewJob: (jobId) => `${base + api}inventories/paid-features/preview-jobs/${jobId}/`,
    paidFeatures: base + api + 'inventories/paid-features/',
    statusUpdatePreview: base + api + 'inventories/status-updates/preview/',
    statusUpdates: base + api + 'inventories/status-updates/',
    olxAdBulkDetail: base + api + 'inventories/olx-ads/bulk-detail/',
    olxAdDetail: (accountId, adId) => `${base + api}inventories/olx-ads/${accountId}/${adId}/`,
    draftDetail: (draftId) => `${base + api}inventories/drafts/${draftId}/`,
    draftImages: (draftId) => `${base + api}inventories/drafts/${draftId}/images/`,
    draftImagesReorder: (draftId) => `${base + api}inventories/drafts/${draftId}/images/reorder/`,
    draftImageDetail: (draftId, imageId) => `${base + api}inventories/drafts/${draftId}/images/${imageId}/`,
    postingPlans: base + api + 'inventories/plans/',
    postingPlanDetail: (planId) => `${base + api}inventories/plans/${planId}/`,
    postingPlanResults: (planId) => `${base + api}inventories/plans/${planId}/results/`,
    postingPlanSchedule: (planId) => `${base + api}inventories/plans/${planId}/schedule/`,
    postingPlanGenerated: base + api + 'inventories/plans/generated/',
    postingPlanGeneratedPreview: base + api + 'inventories/plans/generated/preview/',
    postingPlanItemAttempts: (itemId) => `${base + api}inventories/plan-items/${itemId}/attempts/`,
    scheduledActions: base + api + 'inventories/scheduled-actions/',
    scheduledActionsBulkPreview: base + api + 'inventories/scheduled-actions/bulk/preview/',
    scheduledActionsBulkCancel: base + api + 'inventories/scheduled-actions/bulk/cancel/',
    scheduledActionsBulkReschedule: base + api + 'inventories/scheduled-actions/bulk/reschedule/',
    scheduledActionGroupDetail: (planId) => `${base + api}inventories/scheduled-actions/groups/${planId}/`,
    scheduledActionGroupCancel: (planId) => `${base + api}inventories/scheduled-actions/groups/${planId}/cancel/`,
    scheduledActionGroupReschedule: (planId) => `${base + api}inventories/scheduled-actions/groups/${planId}/reschedule/`,
    scheduledActionDetail: (itemId) => `${base + api}inventories/scheduled-actions/${itemId}/`,
    scheduledActionCancel: (itemId) => `${base + api}inventories/scheduled-actions/${itemId}/cancel/`,
    scheduledActionReschedule: (itemId) => `${base + api}inventories/scheduled-actions/${itemId}/reschedule/`,
    threads: base + api + 'threads/get/',
    openThread: base + api + 'threads/open/',
    filteredThreads: base + api + 'threads/filter/',
    newThreads: base + api + 'threads/new/',
    threadAccessEntitlement: base + api + 'threads/access-entitlement/',
    resumeThreadUsageGuard: base + api + 'threads/usage-guard/resume/',
    sendMessage: base + api + 'threads/send/',
    createThreadNote: base + api + 'threads/notes/create/',
    updateThreadNote: (noteId) => `${base + api}threads/notes/${noteId}/update/`,
    deleteThreadNote: (noteId) => `${base + api}threads/notes/${noteId}/delete/`,
    messageTemplates: (query = '') => `${base + api}threads/templates/${query ? `?q=${encodeURIComponent(query)}` : ''}`,
    messageTemplateUpdate: (templateId) => `${base + api}threads/templates/${templateId}/update/`,
    messageTemplateDelete: (templateId) => `${base + api}threads/templates/${templateId}/delete/`,
    scheduledMessageQuota: base + api + 'threads/scheduled/quota/',
    scheduleMessage: base + api + 'threads/scheduled/send/',
    scheduledMessageList: base + api + 'threads/scheduled/list/',
    scheduledMessageUpdate: (itemId) => `${base + api}threads/scheduled/${itemId}/update/`,
    scheduledMessageCancel: (itemId) => `${base + api}threads/scheduled/${itemId}/cancel/`,
    getMessages: base + api + 'threads/messages/',
    markThread: base + api + 'threads/mark/',
    actThread: base + api + 'threads/action/',
    getPackages: base + api + 'billing/packages/',
    getSubscriptions: base + api + 'billing/subscriptions/',
    getUserBilling: base + api + 'billing/get_billing/',
    getUserCards: base + api + 'billing/get_cards/',
    setUserCardState: base + api + 'billing/set_card_state/',
    setUserCardDefault: base + api + 'billing/set_card_default/',
    addUserCard: base + api + 'billing/add_card/',
    deleteUserCard: base + api + 'billing/delete_card/',
    getUserSubscriptions: base + api + 'billing/user_subscriptions/',
    getSubscriptionsUpgradeQuote: base + api + 'billing/upgrade_quote/',
    getProviders: base + api + 'billing/get_payment_providers/',
    getSubscriptionProviders: base + api + 'billing/get_subscription_providers/',
    purchasePackage: base + api + 'billing/purchase_package/',
    subscribe: base + api + 'billing/subscribe/',
    subscribeUpgrade: base + api + 'billing/subscribe/upgrade/',
    subscribeCancel: base + api + 'billing/subscribe/cancel/',
    refillBalance: base + api + 'billing/refill_balance/',
    changeEmail: base + api + auth + 'users/me/',
    changePassword: base + api + auth + 'users/set_password/',
    getBotSourcesEndpoint: (botId) => `${apiBase}bots/${botId}/sources/`,
    integrationsAvailableByRole: (role = 'source') => `${apiBase}integrations/available-by-role/?role=${encodeURIComponent(role)}`,
};

export default urls;
